import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const AppContext = createContext(null);

export const LANGUAGES = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "ro", label: "Română" },
  { code: "uk", label: "Українська" },
  { code: "tr", label: "Türkçe" },
  { code: "pl", label: "Polski" },
  { code: "ru", label: "Русский" },
  { code: "ar", label: "العربية" },
  { code: "bg", label: "Български" },
  { code: "it", label: "Italiano" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
];

export function AppProvider({ children }) {
  const [language, setLanguage] = useState(
    () => localStorage.getItem("ba_lang") || "de"
  );
  const [token, setToken] = useState(() => localStorage.getItem("ba_token") || "");
  const [user, setUser] = useState(null);
  const [currentResult, setCurrentResult] = useState(null); // last analysis
  const [todoState, setTodoState] = useState({}); // {stepIdx: bool}
  const [loyaltyActive, setLoyaltyActive] = useState(false);

  useEffect(() => { localStorage.setItem("ba_lang", language); }, [language]);
  useEffect(() => {
    if (token) localStorage.setItem("ba_token", token);
    else localStorage.removeItem("ba_token");
  }, [token]);

  useEffect(() => {
    if (!token) { setUser(null); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUser(r.data))
      .catch(() => { setToken(""); setUser(null); });
  }, [token]);

  // Fetch loyalty status for paid users — powers the golden badge in the header
  useEffect(() => {
    if (!user || !token) { setLoyaltyActive(false); return; }
    if (user.subscription !== "plus" && user.subscription !== "premium") {
      setLoyaltyActive(false); return;
    }
    axios.get(`${API}/payments/loyalty-status`,
              { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setLoyaltyActive(!!r.data.applied))
      .catch(() => setLoyaltyActive(false));
  }, [user, token]);

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  const value = {
    language, setLanguage,
    token, setToken,
    user, setUser,
    currentResult, setCurrentResult,
    todoState, setTodoState,
    loyaltyActive, setLoyaltyActive,
    authHeaders,
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
}
